import { Component, inject } from '@angular/core';
import { MessageToastContainerComponent } from '@lib/components/organisms/message-toast';
import { MessageToastService } from '@common/app/services/message-toast.service';

@Component({
  selector: 'eq-message-toast-host',
  standalone: true,
  imports: [MessageToastContainerComponent],
  template: `
    <eq-message-toast-container
      [items]="messageToasts.items()"
      (dismissItem)="messageToasts.dismiss($event)"
    />
  `,
})
export class MessageToastHostComponent {
  readonly messageToasts = inject(MessageToastService);
}
